import React, { useEffect, useState, useMemo, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Tab, Tabs, Button } from '@mui/material';
import moment from 'moment';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { toast } from 'react-toastify';
import axios from 'axios';
import { DashboardProvider } from '../Dashboard/useDashboard';
import TabPanel from '../../components/TabPanel';
// Context
import AppConst from '../../components/AppLayout/const';
import useProductAllocationContext from './context/useProductAllocationContext';
// Components
import Filter from './components/Filter';
import Table from './components/Table';
import Importmodal from './components/ImportModal';
import ProductInventoryBalanceModal from './components/ProductInventoryBalanceModal';
// API
import {
  postProductAllocationList,
  postDownloadTemplate,
  postProductAllocationExport,
} from '../../api/productAllocationApi';

let cancelRequest;

export default function ProductAllocation() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  const defaultFilter = {
    department: { label: 'ALL', value: null },
    team: { label: 'ALL', value: activeTab === 0 ? 'ALPHA' : 'DELTA' },
    manager_id: { label: 'ALL', value: null },
    rep_id: { label: 'ALL', value: null },
    md_id: { label: 'ALL', value: null },
    group: { label: 'ALL', value: null },
    specialty: { label: 'ALL', value: null },
    product: { label: 'ALL', value: null },
    month_year: moment().format('YYYY-MM'),
  };

  const { onSetTitle } = useContext(AppConst.AppContext);
  const [loading, setLoading] = useState(false);
  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [productAllocations, setProductAllocations] = useState([]);
  const [importModal, setImportModal] = useState({ toggle: false });
  const [productInventoryBalanceModal, setProductInventoryModal] = useState({
    toggle: false,
    rep_id: null,
    rep_name: null,
  });

  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleProductInventoryBalanceModal = (value, name) => {
    toast.loading('Processing request please kindly wait...');
    setProductInventoryModal({
      ...productInventoryBalanceModal,
      toggle: true,
      rep_id: value,
      rep_name: name,
    });
    toast.dismiss();
  };

  const handleGenerateFilter = async (reset = null) => {
    try {
      if (cancelRequest) {
        cancelRequest.cancel('request_cancelled');
        toast.dismiss();
      }
      cancelRequest = axios.CancelToken.source();

      setLoading(true);
      let request;
      if (reset === 'reset') {
        request = {
          team: activeTab === 0 ? 'ALPHA' : 'DELTA',
          rep_id: defaultFilter?.rep_id?.value,
          md_id: defaultFilter?.md_id?.value,
          group: defaultFilter?.group?.value,
          specialty: defaultFilter?.specialty?.value,
          product: defaultFilter?.product?.value,
          month: moment(defaultFilter?.month_year).format('M'),
          year: moment(defaultFilter?.month_year).format('YYYY'),
        };
      } else {
        request = {
          team: activeTab === 0 ? 'ALPHA' : 'DELTA',
          rep_id: filterForm?.rep_id?.value,
          md_id: filterForm?.md_id?.value,
          group: filterForm?.group?.value,
          specialty: filterForm?.specialty?.value,
          product: filterForm?.product?.value,
          month: moment(filterForm?.month_year).format('M'),
          year: moment(filterForm?.month_year).format('YYYY'),
        };
      }

      const response = await postProductAllocationList(request, {
        cancelToken: cancelRequest.token,
      });

      if (response?.data?.code === '200') {
        setTableHeaders(response?.data?.headers);
        setProductAllocations(response?.data?.data);

        setLoading(false);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleClearFilter = () => {
    setFilterForm(defaultFilter);
    handleGenerateFilter('reset');
  };

  const handleDownloadTemplate = async () => {
    try {
      toast.loading('Processing request please kindly wait...');
      const request = {
        month: moment(filterForm?.month_year).format('MM'),
        year: moment(filterForm?.month_year).format('YYYY'),
      };
      const response = await postDownloadTemplate(request);
      const { code, result } = response.data.response;
      if (code === '200') {
        const fileName = response?.data?.response?.file_name;
        toast.dismiss();
        toast.success(`File has been successfully downloaded file name: ${fileName}`);

        const url = result;
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleImportModal = () => {
    setImportModal({ ...importModal, toggle: true });
  };

  const handleProductAllocationExport = async () => {
    try {
      toast.loading('Processing request please kindly wait...');
      const request = {
        team: activeTab === 0 ? 'ALPHA' : 'DELTA',
        rep_id: filterForm?.rep_id?.value,
        md_id: filterForm?.md_id?.value,
        group: filterForm?.group?.value,
        specialty: filterForm?.specialty?.value,
        product: filterForm?.product?.value,
        month: moment(filterForm?.month_year).format('M'),
        year: moment(filterForm?.month_year).format('YYYY'),
      };

      const response = await postProductAllocationExport(request);

      const { code, result } = response.data.response;
      if (code === '200') {
        window.location.href = result;
        toast.success(`Successfully downloaded file: ${response?.data?.response?.file_name}`);
      }
      toast.dismiss();
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  onSetTitle('Product Sample Allocation');

  useEffect(() => {
    handleGenerateFilter();
  }, [activeTab]);
  return (
    <DashboardProvider>
      <useProductAllocationContext.Provider
        value={useMemo(
          () => ({
            loading,
            filterForm,
            tableHeaders,
            productAllocations,
            importModal,
            productInventoryBalanceModal,
            setLoading,
            setFilterForm,
            setImportModal,
            setProductInventoryModal,
            handleGenerateFilter,
            handleClearFilter,
            handleProductInventoryBalanceModal,
          }),
          [
            loading,
            filterForm,
            productAllocations,
            importModal.toggle,
            productInventoryBalanceModal.toggle,
          ],
        )}
      >
        <Box sx={{ backgroundColor: '#fff', p: 1, boxShadow: 3 }}>
          <Filter />
        </Box>

        <Box padding={4}>
          <Grid container spacing={2}>
            <Grid xs={12} sm={12} md={12}>
              <Box sx={{ backgroundColor: '#fff' }} mt={4}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs
                    value={activeTab}
                    onChange={handleChangeActiveTab}
                    aria-label='basic tabs example'
                  >
                    <Tab label='Alpha' id='alpha' aria-controls='alpha' />
                    <Tab label='Delta' id='delta' aria-controls='delta' />
                  </Tabs>
                </Box>
                <TabPanel value={activeTab} index={activeTab}>
                  <Box>
                    <Grid container spacing={2}>
                      <Grid md={12}>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                          }}
                        >
                          <Button
                            variant='text'
                            color='primary'
                            onClick={() => navigate('/maintenance/product-inventory-balance-v2')}
                            sx={{
                              marginLeft: '10px',
                              marginBottom: '20px',
                              paddingTop: '10px',
                            }}
                          >
                            Go To Product Inventory Balance (ALL MPR)
                          </Button>

                          <Button
                            variant='contained'
                            color='warning'
                            onClick={handleDownloadTemplate}
                            startIcon={<DownloadIcon />}
                            sx={{
                              marginLeft: '10px',
                              marginBottom: '20px',
                              paddingTop: '10px',
                            }}
                          >
                            Download Template
                          </Button>

                          <Button
                            variant='contained'
                            color='warning'
                            onClick={handleImportModal}
                            startIcon={<UploadIcon />}
                            sx={{
                              marginLeft: '10px',
                              marginBottom: '20px',
                              paddingTop: '10px',
                            }}
                          >
                            Import/Upload
                          </Button>

                          <Button
                            variant='contained'
                            color='warning'
                            onClick={handleProductAllocationExport}
                            startIcon={<CloudDownloadIcon />}
                            sx={{
                              marginLeft: '10px',
                              marginBottom: '20px',
                              paddingTop: '10px',
                            }}
                          >
                            Export
                          </Button>
                        </Box>
                      </Grid>
                      <Grid md={12}>
                        <Table />
                      </Grid>
                    </Grid>
                  </Box>
                </TabPanel>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Importmodal />
        {productInventoryBalanceModal.toggle ? <ProductInventoryBalanceModal /> : ''}
      </useProductAllocationContext.Provider>
    </DashboardProvider>
  );
}
